// components/CustomerTable.js
import axios from "./../../utils/axiosInstance";
import React, { useEffect, useState } from "react";
import "./Customers.css";
import { IoMdArrowDropdown } from "react-icons/io";

const CustomerTable = () => {
  const [customers, setCustomers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [selectedNumbers, setSelectedNumbers] = useState("50");

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASED_URL}/stats/customers?itemsPerPage=${itemsPerPage}&currentPage=${currentPage}`
        );
        const data = await response.data;
        console.log(data.customers);
        setCustomers(data.customers);
        setTotalCount(data.totalCount);
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };
    fetchCustomers();
  }, [currentPage, itemsPerPage]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // Reset to page 1 when changing items per page
  };

  const CustomSelect = ({ options, value, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleOptionClick = (optionValue) => {
      onChange(optionValue);
      setIsOpen(false);
      handleItemsPerPageChange(parseInt(optionValue));
    };

    return (
      <div
        className={`flex flex-row rounded-3xl relative w-16 bg-transparent text-neutral-950 text-[12px] focus:outline-none focus:ring-0`}
      >
        <button
          className={`flex flex-row items-center justify-center w-full text-center text-base`}
          onClick={() => setIsOpen(!isOpen)}
        >
          {options.find((option) => option.value === value)?.text || "50"}
          <IoMdArrowDropdown
            className={`size-6 pl-2 items-center justify-center bg-transparent text-neutral-950`}
          />
        </button>
        {isOpen && (
          <ul
            className={`mt-1 rounded-xl absolute top-[120%] left-0 text-left border bg-white border-neutral-300 w-full z-10`}
          >
            <li
              key={"10"}
              className={`rounded-xl gap-1 m-1 text-center py-2 text-base hover:bg-neutral-200 cursor-pointer`}
              onClick={() => handleOptionClick("10")}
            >
              {"10"}
            </li>
            <li
              key={"20"}
              className={`rounded-xl gap-1 m-1 text-center py-2 text-base hover:bg-neutral-200 cursor-pointer`}
              onClick={() => handleOptionClick("20")}
            >
              {"20"}
            </li>
            <li
              key={"50"}
              className={`rounded-xl gap-1 m-1 text-center py-2 text-base hover:bg-neutral-200 cursor-pointer`}
              onClick={() => handleOptionClick("50")}
            >
              {"50"}
            </li>
            <li
              key={"100"}
              className={`rounded-xl gap-1 m-1 text-center py-2 text-base hover:bg-neutral-200 cursor-pointer`}
              onClick={() => handleOptionClick("100")}
            >
              {"100"}
            </li>
          </ul>
        )}
      </div>
    );
  };

  const options = [
    { value: "10", text: "10" },
    { value: "20", text: "20" },
    { value: "50", text: "50" },
    { value: "100", text: "100" },
  ];

  const handleAllowedToggle = async (customerEmail, currentValue) => {
    try {
      const updatedValue = !currentValue;

      // Send the updated value to the backend (API request)
      const response = await axios.put(
        `${process.env.REACT_APP_BASED_URL}/stats/customers/${customerEmail}`,
        {
          allowedByMe: updatedValue,
        }
      );

      if (response.status === 200) {
        // Update the state with the new value
        setCustomers(
          customers.map((customer) =>
            customer.email === customerEmail
              ? { ...customer, allowedByMe: updatedValue }
              : customer
          )
        );
      }
    } catch (error) {
      console.error("Error updating allowedByMe:", error);
    }
  };

  return (
    <div className="flex flex-col gap-2 bg-sky-50 px-2 py-5 w-[85vw]">
      <div className="flex flex-row items-end justify-between">
        <p className="text-neutral-500 text-4xl px-5 py-2">Customers</p>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th>No</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Joined Date</th>
            <th>Allowed</th>
            <th>Plan</th>
            <th>Expiring Date</th>
            <th>Spent</th>
            <th>Used Credits</th>
            <th>Last Charged Date</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer, index) => (
            <tr key={customer.email}>
              <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
              <td>{customer.name}</td>
              <td>{customer.email}</td>
              <td>{customer.phoneNumber}</td>
              <td>{new Date(customer.createdAt).toLocaleDateString()}</td>
              <td>
                <button
                  onClick={() =>
                    handleAllowedToggle(customer.email, customer.allowedByMe)
                  }
                  className={`w-20 py-1 px-3 rounded-full ${
                    customer.allowedByMe
                      ? "bg-green-400 text-white"
                      : "bg-red-400 text-neutral-800"
                  } font-medium`}
                >
                  {customer.allowedByMe ? "True" : "False"}
                </button>
              </td>
              <td>{customer.plan?.level}</td>
              <td>{new Date(customer.plan?.endDate).toLocaleDateString()}</td>
              <td>${customer.spent?.amount}</td>
              <td>{customer.plan?.creditsUsed}</td>
              <td>
                {new Date(customer.spent?.lastCharged).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex flex-row gap-5 items-center justify-end pr-5 pt-5">
        <div className="pr-5 text-xl">
          Showing results {(currentPage - 1) * itemsPerPage + 1} to{" "}
          {Math.min(currentPage * itemsPerPage, totalCount)} of {totalCount}
        </div>
        <button
          className="bg-blue-400 p-2 rounded-2xl font-medium w-16 text-neutral-50 !disabled:hover:bg-blue-500 !disabled:cursor-pointer"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Prev
        </button>
        <button
          className="bg-blue-400 p-2 rounded-2xl font-medium w-16 text-neutral-50 !disabled:hover:bg-blue-500 !disabled:cursor-pointer"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage * itemsPerPage >= totalCount}
        >
          Next
        </button>

        <CustomSelect
          options={options}
          value={selectedNumbers}
          onChange={(value) => setSelectedNumbers(value)}
        />
      </div>
    </div>
  );
};

export default CustomerTable;
